module.exports = __webpack_public_path__ + "static/media/uber-logo.58f729b4.svg";